export default "__VITE_ASSET__BL7y2G7t__"